$rise_resize $mol_view
	sub /
		<= Drag_view $rise_drag_view
			minimal_height 0
			sub <= drag_body /
			x? <=> x? 0
			y? <=> y? 0
			on_drag_start? <=> on_drag_start? null
			on_drag? <=> on_drag? null
			on_drag_end? <=> on_drag_end? null
			dragged => dragged
			drags_synced <= drags_synced /$rise_drag
			Drag => Drag
			repos_x* <= repos_x* 1
			repos_y* <= repos_y* 1
			pointerdown? => drag_pointerdown?
		^ controls /
		^ edges /
			<= Top_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> top_edge_y? 0
			<= Left_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				x? <=> left_edge_x? 0
			<= Bottom_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> bottom_edge_y? 0
			<= Right_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				x? <=> right_edge_x? 0
			<= Top_left_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> top_edge_y? 0
				x? <=> left_edge_x? 0
			<= Top_right_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> top_edge_y? 0
				x? <=> right_edge_x? 0
			<= Bottom_left_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> bottom_edge_y? 0
				x? <=> left_edge_x? 0
			<= Bottom_right_edge $rise_resize_edge
				repos_x* <= repos_x*
				repos_y* <= repos_y*
				on_drag_start? <=> resize_start? null
				on_drag_end? <=> resize_end? null
				y? <=> bottom_edge_y? 0
				x? <=> right_edge_x? 0
	resizing? false
	transforming false
	-
	height_min 20
	width_min 20
	-
	height? 0
	width? 0
	top? 0
	left? 0
	-
	stick_threshold 10
	-
	x_stick? 0
	y_stick? 0
	bottom_edge_y_stick? <= height_min
	right_edge_x_stick? <= width_min
	top_edge_y_stick? 0
	left_edge_x_stick? 0
	-
	stickable? true
	sticks_y /number
	sticks_x /number
	auto /
		<= x?
		<= y?
		<= left_edge_x?
		<= right_edge_x?
		<= top_edge_y?
		<= bottom_edge_y?
	-
	style *
		^
		top <= top_px \0px
		left <= left_px \0px
		height <= height_px \20px
		width <= width_px \20px

$rise_resize_edge $rise_drag_view
